import { ComputedQuery, FiltersMap } from '../model';
import { IterateeShorthand } from 'lodash';

type Iterator<T> = (value: T, index: number) => unknown;

export interface Order<T> {
  fieldName: Iterator<T> | IterateeShorthand<T>;
  order: 'asc' | 'desc';
}

export interface QueryResultSimulation<T, F extends FiltersMap> {
  readonly predicate: (computedQuery: ComputedQuery<F>) => (item: T) => boolean;
  readonly orderBy: (computedQuery: ComputedQuery<F>) => Order<T>[];
}
